import compile from "./core/compile";
import compileFromFile from "./core/compileFromFile";
import debug from "./core/debug";
import createFunction from "./core/createFunction";
import compileFromFileBrowser from "./core/compileFromFileBrowser";

export default {
  compile,
  compileFromFile,
  compileFromFileBrowser,
  createFunction,
  debug,
};
